import { createPortal } from "react-dom";
import { useEffect } from "react";
import { IoClose } from "react-icons/io5";

export const Modal = ({ isOpen, onClose, children }) => {
    useEffect(() => {
        const handler = (e) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handler);

        // Lock scroll when modal is open
        let scrollY = 0;
        if (isOpen) {
            scrollY = window.scrollY;
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.width = '100%';
            document.body.style.top = `-${scrollY}px`;
        }

        return () => {
            document.removeEventListener("keydown", handler);
            // Restore scroll when modal is closed
            if (isOpen) {
                const savedScrollY = document.body.style.top;
                document.body.style.overflow = '';
                document.body.style.position = '';
                document.body.style.width = '';
                document.body.style.top = '';
                window.scrollTo(0, parseInt(savedScrollY || '0') * -1);
            }
        };
    }, [onClose, isOpen]);

    if (!isOpen) return null;

    return createPortal(
        <div className="fixed inset-0 z-50 flex items-start sm:items-center justify-center bg-black/60 backdrop-blur-sm overflow-y-auto">
            <div className="bg-white rounded-2xl w-[95%] max-w-[500px] relative my-4 mx-auto transform transition-all duration-300 ease-in-out mt-[10vh] sm:mt-0">
                <button
                    onClick={onClose}
                    className="absolute -top-3 -right-3 text-black z-10 flex items-center justify-center p-1.5 size-7 bg-[#f6b51b] rounded-full transition-colors duration-200 hover:bg-[#f6b51b]/90 shadow-lg"
                >
                    <IoClose size={20} />
                </button>
                {children}
            </div>
        </div>,
        document.body
    );
};
